import { render } from "./About.vue?vue&type=template&id=a40c9a78"
const script = {}
script.render = render

export default script